function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoicemailPhonePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    points: "20.56 22.69 20.56 25.62 24.37 21.88 20.56 17.62 20.56 20.56",
    style: {
      fill: "#24a6df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.14,20l-.26.16c-.53.36-2.46.19-4.06-2.66s-.82-4.67-.26-4.89L13.63,12a1.12,1.12,0,0,0,.45-1.4L12,6.86a1.11,1.11,0,0,0-1.42-.44c0,.07-1.14.61-1.14.7C7.87,8,7.07,9.85,7.16,12.45a15.25,15.25,0,0,0,2.2,6.85,17.07,17.07,0,0,0,4.77,5.41,8.87,8.87,0,0,0,1.95,1Z",
    style: {
      fill: "#7e7e7e"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoicemailPhonePlay);
export default __webpack_public_path__ + "static/media/voicemail-phone_play.15f88c38.svg";
export { ForwardRef as ReactComponent };